import { ZIndex } from './types';

export const zIndices: Partial<ZIndex> = {
  aboveSibling: 1,
  foreground: 100,
  // This is used for our custom Popover component used by the datepicker
  // We had a clash in names so we are using a prefix/suffix to prevent that
  __popover__: 200,
  overlayFg: 900,
  fullPageOverlay: 500,
};
